<!--
 * @Author: yihao yihao@meiomedical.com
 * @Date: 2025-06-06 16:32:45
 * @LastEditors: yihao yihao@meiomedical.com
 * @LastEditTime: 2025-10-22 12:19:24
 * @FilePath: \website_vue1\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <!-- 顶部导航 -->
    <homeHeader  ref="homeHeader"/>
    <!-- 路由出口，显示对应页面组件 -->
       <!-- 页面切换动画 -->
    <!-- 页面切换动画 -->
    <transition name="fade" mode="out-in">
      <router-view :key="$route.fullPath" />
    </transition>
      <!-- 底部导航 -->
    <homeFooter />
  </div>
</template>

<script>
import homeHeader from './components/homeHeader.vue'

import homeFooter from './components/homeFooter.vue'
export default {
  components: {
    homeHeader,
    homeFooter
  },
  name: 'App'
}

</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  font-family: 'D-DIN-PRO', sans-serif;
}

/* Regular (正常) */
/* D-DIN-PRO 400 Regular */
@font-face {
  font-family: 'D-DIN-PRO';
  src: url('@/assets/fonts/D-DIN PRO/D-DIN-PRO-400-Regular.otf') format('opentype');
  font-weight: 400;
  font-style: normal;
}

/* D-DIN-PRO 500 Medium */
@font-face {
  font-family: 'D-DIN-PRO';
  src: url('@/assets/fonts/D-DIN PRO/D-DIN-PRO-500-Medium.otf') format('opentype');
  font-weight: 500;
  font-style: normal;
}

/* D-DIN-PRO 600 SemiBold */
@font-face {
  font-family: 'D-DIN-PRO';
  src: url('@/assets/fonts/D-DIN PRO/D-DIN-PRO-600-SemiBold.otf') format('opentype');
  font-weight: 600;
  font-style: normal;
}

/* D-DIN-PRO 700 Bold */
@font-face {
  font-family: 'D-DIN-PRO';
  src: url('@/assets/fonts/D-DIN PRO/D-DIN-PRO-700-Bold.otf') format('opentype');
  font-weight: 700;
  font-style: normal;
}

/* D-DIN-PRO 800 ExtraBold */
@font-face {
  font-family: 'D-DIN-PRO';
  src: url('@/assets/fonts/D-DIN PRO/D-DIN-PRO-800-ExtraBold.otf') format('opentype');
  font-weight: 800;
  font-style: normal;
}

/* D-DIN-PRO 900 Heavy */
@font-face {
  font-family: 'D-DIN-PRO';
  src: url('@/assets/fonts/D-DIN PRO/D-DIN-PRO-900-Heavy.otf') format('opentype');
  font-weight: 900;
  font-style: normal;
}




body {
  margin: 0; /* 去掉浏览器默认外边距 */
  padding: 0;
}
/* html, body {
  overflow-x: hidden;
} */
 /* 针对整个页面滚动条 */
::-webkit-scrollbar {
  width: 10px;               /* 滚动条宽度 */
  height: 10px;              /* 横向滚动条高度 */
}

::-webkit-scrollbar-track {
  background: #04132c;       /* 滚动条轨道颜色，深蓝底色 */
  border-radius: 5px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.3); /* 滑块颜色 */
  border-radius: 5px;        /* 滑块圆角 */
  border: 2px solid #04132c; /* 滑块边框，保证和背景融合 */
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.6); /* 滑块悬停颜色 */
}
/* 页面淡入淡出 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

img {
  display: block;
  max-width: 100%;
}
p{
  margin: 0px !important;
}
html {
  font-size: clamp(12px, 1.2vw, 16px);
}


</style>
